import { AxiosInstance } from "axios";

// 管理员权限缓存
let isAdminLoaded = false;
let isAdminCache: boolean | null = null;
let isAdminLoading: Promise<boolean> | null = null;

/**
 * 检查当前用户是否是管理员
 * 使用缓存机制，避免重复请求
 * @param axiosInstance - Axios 实例
 * @param forceRefresh - 是否强制刷新（默认 false）
 * @returns Promise<boolean> - 是否是管理员
 */
export async function checkIsAdmin(
  axiosInstance: AxiosInstance,
  forceRefresh = false
): Promise<boolean> {
  // 如果已经加载过且不强制刷新，直接返回缓存
  if (isAdminLoaded && !forceRefresh) {
    return !!isAdminCache;
  }

  // 如果正在加载中，等待当前请求完成
  if (isAdminLoading) {
    return await isAdminLoading;
  }

  // 创建新的加载请求
  isAdminLoading = (async () => {
    try {
      const res = await axiosInstance.request({
        url: "api/User/IsAdmin",
        method: "post",
      });
      isAdminCache = !!res.data?.Data;
      return isAdminCache;
    } catch (error) {
      console.error("检查管理员权限失败:", error);
      isAdminCache = false;
      return false;
    } finally {
      isAdminLoaded = true;
      isAdminLoading = null;
    }
  })();

  return await isAdminLoading;
}

/**
 * 清除管理员状态缓存
 * 用于登出或需要重新检查权限的场景
 */
export function clearAdminCache() {
  isAdminLoaded = false;
  isAdminCache = null;
  isAdminLoading = null;
}

/**
 * 获取缓存的管理员状态（同步方法）
 * 注意：如果还没有加载过，返回 null
 */
export function getCachedAdminStatus(): boolean | null {
  return isAdminCache;
}

